<div id="{{ 'new-note-' + noteId }}">
    <app-note-quill-editor
        [note]="newNote"
        [quillRange]="quillRange"
        [isFocusNeeded]="isFocusNeeded"
        [noteId]="noteId"
        [toolbarSize]="parentNoteId ? 'small' : 'medium'"
        (isInvalidChanged)="isInvalidMessage = $event"
        (editorCreated)="quillEditor = $event"
        (updateQuillSelection)="updateQuillSelection()"
        (addNote)="addNote()">
    </app-note-quill-editor>
    @if (newNote.attachments.length) {
        <div class="attachments-block mt-2">
            @for (attachment of newNote.attachments; track attachment; let idx = $index) {
                <sb-file-preview
                    class="file-container"
                    [attachments]="newNote.attachments"
                    [ngClass]="{ 'attachment-min-version': isReplyNote || parentNoteId }"
                    [attachment]="attachment"
                    [fileIndex]="idx"
                    [canBeRemoved]="true">
                </sb-file-preview>
            }
            <div class="clearfix"></div>
        </div>
    }
    <div class="mt-2">
        <div class="buttons-panel text-end">
            <button
                class="btn btn-icon"
                (click)="openReplyTemplatesModal($event)"
                tooltip="{{ 'Insert a saved template' | translate }}"
                container="body">
                <sb-inline-svg class="icon" [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Copy icon.svg'">
                </sb-inline-svg>
            </button>
            <button
                class="btn btn-icon"
                (click)="openAttachmentsModal()"
                tooltip="{{ 'Attachments' | translate }}"
                container="body">
                <sb-inline-svg
                    class="icon"
                    [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Attachment icon.svg'">
                </sb-inline-svg>
            </button>
            @if (isCancelAllowed) {
                <button class="btn" (click)="cancel()" translate>cancel</button>
            }
            <button
                class="btn"
                [disabled]="(isInvalidMessage && !newNote.attachments.length) || isAdding"
                (click)="addNote()"
                [ngClass]="{ 'btn-primary': isReplyNote }"
                translate>
                send
            </button>
        </div>
    </div>
</div>
